import {FC} from 'react';

const CloseIcon:FC = () => {
    return (
        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.3133 13.8135L1.68648 1.18655M1.68648 13.8135L14.3133 1.18655" stroke="#EFFEFA" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    );
};

export default CloseIcon;